import React from 'react';

import { cn } from '~/lib/utils';

export type LabelProps = {
  name?: string;
  children?: React.ReactNode;
  htmlFor?: string;
  className?: string;
};

export const Label = React.forwardRef<HTMLLabelElement, LabelProps>(({ className, ...props }, ref) => {
  return (
    <label className={cn('label-sm mb-2 block', className)} {...props} htmlFor={props.htmlFor} ref={ref}>
      {props.children}
    </label>
  );
});

Label.displayName = 'Label';
